/**
 * Copy for Advanced Configuration → AI escalation (version-neutral).
 * Do not embed model identifiers (GPT-x.x); actual models come from backend configuration.
 */

export const ADVANCED_AI_ESCALATION_COPY = {
  /** Subsection title above the escalation alert */
  sectionTitle: 'AI model escalation (admin only)',
  /** MUI Alert — short admin notice; detailed helper is below */
  alertSummary:
    'Optional escalation uses the premium model configured by the deployment for costly AI steps.',
  /** Typography helper under the alert (full explanation) */
  helperFull:
    'Use the project-configured premium model for expensive operations such as Figma semantic understanding and test generation when accuracy is degraded. The actual model is controlled by backend configuration.',
  /** Short line under helper in the alert */
  projectScopedAdminNote: 'Project-scoped; admin privileges required.',
  /** Switch primary label */
  toggleLabel: 'Use high-accuracy model for expensive operations',
  /** When API provides a non-empty model id (e.g. future ai.premium_model) */
  currentPremiumModelPrefix: 'Current premium model:',
  /** When no model name is exposed on the config payload */
  currentConfiguredPremiumFallback: 'Current: configured premium model',
  snackbarEnabled: 'High-accuracy model for expensive operations enabled.',
  snackbarDisabled: 'High-accuracy model for expensive operations disabled.',
  errorToggle: 'Failed to update escalation setting.',
};

/** Keys checked in order when backend exposes an effective premium model label. */
export const PREMIUM_MODEL_CONFIG_KEYS = ['ai.premium_model', 'ai.expensive_operations_premium_model'];

/**
 * @param {Record<string, unknown>|null|undefined} config
 * @returns {string} Single caption line under the toggle
 */
export function formatEscalationPremiumCaption(config) {
  const c = config || {};
  for (const key of PREMIUM_MODEL_CONFIG_KEYS) {
    const v = c[key];
    if (typeof v === 'string' && v.trim()) {
      return `${ADVANCED_AI_ESCALATION_COPY.currentPremiumModelPrefix} ${v.trim()}`;
    }
  }
  return ADVANCED_AI_ESCALATION_COPY.currentConfiguredPremiumFallback;
}
